import axios from "axios";
import { getApiErrorResponse } from "./helper";
import { ProcessedApiResponse, RequestParams } from "./interfaces";

const baseApiUrl = process.env.REACT_APP_BASE_API_URL;

export const GET = async <Data>(
  endpoint: string,
  { params = {}, headers = {} }: RequestParams = {},
  useBaseUrl = true,
) =>
  new Promise<ProcessedApiResponse<Data>>((resolve) => {
    const processedParams = { ...params };

    axios
      .get<ProcessedApiResponse<Data>>(`${useBaseUrl ? baseApiUrl : ""}${endpoint}`, {
        params: processedParams,
        headers,
      })
      .then((response) => resolve(response.data))
      .catch(() => resolve(getApiErrorResponse()));
  });

export const POST = async <Data = undefined>(
  endpoint: string,
  { params = {}, headers = {} }: RequestParams = {},
  useBaseUrl = true,
) =>
  new Promise<ProcessedApiResponse<Data>>((resolve) => {
    axios
      .post<ProcessedApiResponse<Data>>(
        `${useBaseUrl ? baseApiUrl : ""}${endpoint}`,
        params,
        {
          headers,
        },
      )
      .then((response) => resolve(response.data))
      .catch(() => resolve(getApiErrorResponse()));
  });
